import { Action, Dispatch, bindActionCreators } from 'redux';
import { DateSelector, DateSelectorProps } from '../core/DateSelector';

import { RootState } from '../../redux/types';
import { connect } from 'react-redux';
import { setDate } from '../../redux/ui/actions';

const mapStateToProps = (state: RootState, ownProps: DateSelectorProps): DateSelectorProps => {
  return {
    ...ownProps,
    defaultDate: state.ui.date,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: DateSelectorProps): DateSelectorProps => {
  const actions = bindActionCreators({ setDate }, dispatch);
  return {
    ...ownProps,
    onChange: actions.setDate,
  };
};

export const VisitDateSelector = connect(mapStateToProps, mapDispatchToProps)(DateSelector);
